var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SaiMultiSelect',{staticClass:"bulkAction",attrs:{"labelBy":"val","trackBy":"key","searchable":false,"resetAfter":true,"placeholder":_vm.$t('frm_actions'),"options":_vm.actions},on:{"change":_vm.triggerBulkAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }